export default __webpack_public_path__ + "static/media/lesswrong-mark.ef1c37d7.webp";